// import type { RenderEditCellProps } from 'react-data-grid';
// import { textEditorClassname } from 'react-data-grid/editors/textEditor';
// import type { Row } from '../AllFeatures';
import { TKeyValuePair } from '@/types';
import * as Styled from './styled';

import { RenderEditCellProps } from 'react-data-grid';

function autoFocusAndSelect(input: HTMLInputElement | null) {
  input?.focus();
  input?.select();
}

export function booleanEditor<TRow, TSummaryRow>({
  row,
  column,
  onRowChange,
  onClose,
}: RenderEditCellProps<TRow, TSummaryRow>) {
  const options: { label: string; value: any }[] = [
    { label: 'true', value: true },
    { label: 'false', value: false },
    { label: 'null', value: 'NULL_HANDLER' },
  ];

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value === 'NULL_HANDLER' ? null : event.target.value;
    onRowChange({ ...row, [column.key]: value });
  };

  const rowValue = row[column.key as keyof TRow] || null;
  const val = rowValue === null ? 'NULL_HANDLER' : rowValue;
  return (
    <Styled.BooleanSelect
      value={val as unknown as string}
      onChange={handleChange}
      autoFocus
      onBlur={() => onClose(true, false)}
    >
      {options.map((option) => (
        <option key={option.label} value={option.value}>
          {option.label}
        </option>
      ))}
    </Styled.BooleanSelect>

    // <input
    //   className={textEditorClassname}
    //   ref={autoFocusAndSelect}
    //   value={row[column.key as keyof TRow] as unknown as string}
    //   onChange={(event) => onRowChange({ ...row, [column.key]: event.target.value })}
    //   onBlur={() => onClose(true, false)}
    // />
  );
}

export function numericInput<TRow, TSummaryRow>({
  row,
  column,
  onRowChange,
  onClose,
}: RenderEditCellProps<TRow, TSummaryRow>) {
  return (
    <Styled.NumericInput
      ref={autoFocusAndSelect}
      type="number"
      value={row[column.key as keyof TRow] as unknown as string}
      onChange={(event) => onRowChange({ ...row, [column.key]: event.target.value })}
      onBlur={() => onClose(true, false)}
    />

    // <input
    //   className={textEditorClassname}
    //   ref={autoFocusAndSelect}
    //   value={row[column.key as keyof TRow] as unknown as string}
    //   onChange={(event) => onRowChange({ ...row, [column.key]: event.target.value })}
    //   onBlur={() => onClose(true, false)}
    // />
  );
}
